<template>
  <v-container>
    <v-layout row wrap align-center justify-center>
      <v-flex lg2 md4 sm4 xs6 v-for="story in storeStories" :key="story.id">
        <stories-card
          :audio="story.audio"
          :photos="story.photos"
          :mainPhotoUrl="story.mainPhotoUrl"
          :subTitleText="story.subTitleText"
          :name="story.name"
         />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import StoriesCard from "../../components/StoriesCard/StoriesCard";
import { mapState } from "vuex";

export default {
  data() {
    return {
    };
  },
  components: {
    StoriesCard
  },
  computed: {
    ...mapState({
      storeStories(state) {
        return state.storeStories;
      }
    }),
  },
  methods: {
  }
};
</script>

<style lang="stylus" scoped>
.peopleTextFlex {
  margin: 2rem;
}

.marginFilter {
  margin: 0 0.8rem 0 0;
}
</style>
